<template>
	<div class="relative">


		<el-button @click="play">播放</el-button>
		<el-button @click="pause">暂停</el-button>
	</div>
</template>

<script>
	import WaveSurfer from 'wavesurfer.js'
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		props: ['url'],
		data() {
			return {}
		},

		mounted() {
			// 1. 创建Audio实例，传入音频URL
			const audio = new Audio(this.url);

			this.audio = audio;

			// 2. 播放音频（需用户交互触发，如点击事件，避免浏览器自动播放限制）
			function playAudio() {
				audio.play()
					.then(() => console.log('播放开始'))
					.catch(err => console.error('播放失败：', err));
			}

			// 3. 暂停播放
			function pauseAudio() {
				audio.pause();
			}

			// 4. 停止播放（重置到开头）
			function stopAudio() {
				audio.pause();
				audio.currentTime = 0; // 重置播放进度
			}

			// 5. 事件监听
			audio.addEventListener('ended', () => {
				console.log('播放结束');
			});

			audio.addEventListener('error', (err) => {
				console.error('音频错误：', err);
			});
		},

		methods: {

			play() {
				this.audio.play()
					.then(() => console.log('播放开始'))
					.catch(err => console.error('播放失败：', err));
			},

			pause() {
				this.audio.pause();
			},

			stop() {
				this.audio.pause();
				this.audio.currentTime = 0; // 重置播放进度
			},

		}

	}
</script>

<style>
</style>